import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {History} from "../models/History/history";
import {PaymentType} from "../models/History/payment-type.enum";

@Injectable({
    providedIn: "root"
})
export class HistoryHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/wallets";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly searchURL = `${this.fullPath}/history/web`;

    constructor(private http: HttpClient) {
    }

    // * Every filter happens on the back-end
    /**
     *
     * @param serviceId Id e sherbimit
     * @param pageNumber Numri i faqes
     * @param pageSize Madhesia e items qe do mbaj nje faqe
     * @param fromDate Data kur fillon
     * @param toDate Date kur mbaron
     * @param typeOfPayment Tipi i pageses
     * typeOfPayment
     */
    SearchHistory(
        serviceId: number,
        pageNumber: number,
        pageSize: number,
        fromDate: string,
        toDate: string,
        typeOfPayment: PaymentType
    ) {
        const params = new HttpParams()
            .set("serviceId", String(serviceId))
            .append("pageNumber", String(pageNumber))
            .append("pageSize", String(pageSize))
            .append("fromDate", String(fromDate))
            .append("toDate", String(toDate))
            .append("webPaymentType", String(typeOfPayment));

        return this.http.get<History>(this.searchURL, {params});
    }
}
